import { inject } from '@angular/core';
import { MyvehiclesService } from '../services/myvehicles.service';
import { catchError, firstValueFrom, map, of } from 'rxjs';
import { GetVehiclesQueryResultDto } from '../dtos/get-vehicles-query-result.dto';
import { LocalstorageService } from '@services/localstorage.service';

export const myVehiclesResponseResolver = async (): Promise<GetVehiclesQueryResultDto> => {

  const myVehiclesService = inject(MyvehiclesService);
  const localstorageService: LocalstorageService = inject(LocalstorageService);
  const contractId = localstorageService.getContractId();

  try {
    const response = await firstValueFrom(myVehiclesService.getVehiclesDualTag(contractId).pipe(
      map(response => {
        const dualTagVehicles = response;
        localStorage.setItem('vehiclesDualTag', JSON.stringify(dualTagVehicles));
        return response;
      }),
      catchError(error => {
        console.error('Erro ao buscar veículos', error);
        return of({ vehicles: [] } as GetVehiclesQueryResultDto);
      })
    ));

    return response;
  } catch (error) {
    console.error('Erro ao converter para Promise', error);
    throw error;
  }
};
